import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'pages/landing/v2/Main/constants';

export default makeStyles<{ background: string }>({ name: 'Advertising' })((theme, { background }) => ({
    container: {
        display: 'flex',
        padding: '80px 96px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: 24,
        borderRadius: 48,
        background: `url(${background}) center / cover no-repeat #212121`,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: 24
        }
    },
    title: {
        margin: 0,
        color: '#FFFFFF',
        fontSize: 40,
        fontWeight: 700,
        lineHeight: '120%'
    },
    accent: {
        color: '#F5726A'
    },
    description: {
        margin: 0,
        color: '#ECECEC',
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '150%'
    },
    button: {
        height: 56,
        padding: '20px 24px',
        borderRadius: 16,
        background: 'linear-gradient(249deg, #FF8B61 7.18%, #D92E7F 172.88%)',
        color: '#FFF',
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '150%',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: '100%'
        }
    }
}));
